import { PreloaderActionTypes, PRELOADER } from './types';

export function showPreloader(): PreloaderActionTypes {
    return { type: PRELOADER.SHOW };
}

export function hidePreloader(): PreloaderActionTypes {
    return { type: PRELOADER.HIDE };
}
